exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".post-webwidget-v2-player-layout[_v-5a1e986e]{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;font-size:14px;max-width:600px;color:#102027;box-shadow:0 1px 1px silver;background:#f5f5f6;border-radius:5px}.post-webwidget-v2-player-layout [_v-5a1e986e]{transition:all .2s}.post-webwidget-v2-player-layout-top--compact-on-mobile[_v-5a1e986e],.post-webwidget-v2-player-layout-top[_v-5a1e986e]{padding:.5em}@media screen and (max-width:400px){.post-webwidget-v2-player-layout-top[_v-5a1e986e]{padding:0}.post-webwidget-v2-player-layout-top--compact-on-mobile[_v-5a1e986e]{padding:.5em}}.post-webwidget-v2-player-layout-bottom[_v-5a1e986e]{padding:.5em}.post-webwidget-v2-player-layout--dark-theme[_v-5a1e986e]{border-color:#232f37;color:#fff;background:#1f2a32}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5a1e986e&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v2-components/V2PlayerLayout.vue
// module id = 287
// module chunks = 0